export enum LIST_VIEW_STATE {
  EXPANDED = 'EXPANDED',
  EVENT_POPUP_OPEN = 'EVENT_POPUP_OPEN',
  EVENT_LIST_POPUP_OPEN = 'EVENT_LIST_POPUP_OPEN',
}
